import { render, staticRenderFns } from "./imgB.vue?vue&type=template&id=d445f2ba"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d445f2ba')) {
      api.createRecord('d445f2ba', component.options)
    } else {
      api.reload('d445f2ba', component.options)
    }
    module.hot.accept("./imgB.vue?vue&type=template&id=d445f2ba", function () {
      api.rerender('d445f2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgB.vue"
export default component.exports